import React from "react";
import { Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import logo from "../assets/mainLogo.png"
const Sidebar = ({ isOpen, toggleSidebar, isMobile }) => {
    return (
        <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
            <div className="sidebar-header">
                <img src={logo} alt="Logo" className="sidebar-logo" />
                {isMobile && (
                    <button className="close-btn" onClick={toggleSidebar}>
                        <FaTimes />
                    </button>
                )}
            </div>
            <div style={{ borderBottom: "1px solid #feca0a", marginTop: "60px" }}></div>
            <nav >
                <Link to="/" onClick={() => isMobile && toggleSidebar()}>Home</Link>
                <Link to="/services" onClick={() => isMobile && toggleSidebar()}>Services</Link>
                <Link to="/blogs" onClick={() => isMobile && toggleSidebar()}>Blogs</Link>
                <Link to="/about" onClick={() => isMobile && toggleSidebar()}>About</Link>
                <Link to="/contact" onClick={() => isMobile && toggleSidebar()}>Contact</Link>
            </nav>
        </div>
    );
};

export default Sidebar;
